import React from "react";
import "./AboutConference.css";
import bnmit from "../../assets/images/bnmit.webp";
import blore from "../../assets/images/blore.webp";
const AboutConference = () => {
  return (
    <div className="AboutConference">
      <span className="heading">
        about <span>us</span>
      </span>
      <div className="abt-content">
        <span style={{ fontSize: "3.5rem" }}>About The Conference</span>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            textAlign: "justify",
          }}
        >
          <p>
            {/* 2nd International Conference on Intelligent and Innovative Technologies
                        in Computing, Electrical and Electronics ICIITCEE 2025 is organized by BNM Institute of
                        Technology, Bengaluru, India on 24 and 25 January 2025. This conference will feature a comprehensive
                        technical program including several special sessions and workshops. The goal of ICIITCEE 2025 is to
                        provide an outstanding forum for academicians, researchers practitioners, policymakers and students
                        to exchange ideas, techniques and tools, raise awareness, and share experiences related to all
                        practical and theoretical aspects of intelligence and innovations in engineering. ICIITCEE 2025
                        focuses on issues and solutions involving Intelligent and Innovative Technologies in Computing,
                        Electrical and Electronics. Developments in the field of Computing, Electrical and Electronics are
                        very complex and advance rapidly as changes occur on day to day basis. It is very difficult to make
                        it available to all stakeholders researchers, academicians, students, industrialists and society.
                        Hence objectives of the conference is: */}
           In view of the grand success of the third International Conference on Intelligent and Innovative Technologies in Computing, Electrical and Electronics
           (ICIITCEE 2025) organized by BNM Institute of Technology, Bengaluru, India on 16<sup>th</sup> and 17<sup>th</sup> January 2025, the management and the organizers are coming
with the fourth ICIITCEE 2026. The conference received overwhelming response from researchers, academicians and industry. Totally 500 papers were accepted, presented, and published in Xplore. This year, 4<sup>th</sup> ICIITCEE 2026 will be held on 22 and 23 January 2026. This conference
will feature a comprehensive technical program including several special sessions and workshops. The goal of ICIITCEE 2026 is to provide an outstanding
forum for academicians, researchers, practitioners, policymakers, and students to exchange ideas, techniques and tools, raise awareness, and share
experiences related to all practical and theoretical aspects of intelligence and innovations in engineering.<br/>
ICIITCEE 2026 focuses on issues and solutions involving Intelligent and Innovative Technologies in Computing, Electrical and Electronics. Developments in
the field of Computing, Electrical and Electronics are very complex and advance rapidly as changes occur on day-to-day basis. It is very difficult to make it
available to all stakeholders (researchers, academicians, students, industrialists and society). Hence, the objectives of the conference are:
          </p>
          <ul style={{ marginLeft: "5rem" }}>
            <li>
              &mdash;&nbsp;&nbsp;To provide a platform for stakeholders to meet
              and share ideas, views and new findings in the field of
              contemporary Computing, Electrical and Electronics.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To strengthen the relationship with industries
              and academic institutions of Karnataka and Bengaluru and, with
              the rest of the world.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To provide a space for students and researchers
              to meet, discuss, and learn with experts in the related field.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To bridge the gap between the industry and
              academics.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To promote a high level of interaction among
              stakeholders in theoretical, experimental, and applied concepts in
              the field of Computing, Electrical and Electronics.
            </li>
          </ul>
        </div>
        <div className="venue-container">
          <div className="venueimg">
            <img src={bnmit} alt="" />
            <p>
            12th Main Road, 27th Cross, Banashankari II Stage, Banashankari, Bengaluru, Karnataka 560070
            {  /*<a href="">Website</a>*/}
            </p>
          </div>
          <div className="venue-content">
            <span style={{ fontSize: "3.5rem" }}>Conference Venue</span>
            <p>
            Since 2001, B.N.M. Institute of Technology has emerged well-established in
Karnataka, led by the philanthropic and visionary ideas of Founder and
Managing Trustee Shri. N. Raghunath Rao Maanay and Founder Secretary
Prof. Sunanda P Jadhav, and further expanded by Shri. Narayan Rao
Maanay, Secretary, BNM Educational Institutions.
BNMIT is an Autonomous institution since 2021. This most sought-after
institution located in the heart of Bangalore city set on a lush landscaped
green campus. BNMIT offers UG programs in Computer Science, Electrical &
Electronics, Electronics & Communication, Mechanical, Information
Science and Artificial Intelligence & Machine Learning, apart from M Tech
and MBA programs. The institute's state-of-the-art infrastructure includes
Wi-Fi network, digital classrooms, highly sophisticated laboratories with
latest equipment, Industry supported Centers of Excellence, Skill labs, fully
furnished and equipped conference/seminar halls and a large auditorium.
BNMIT has adopted a unique outcome-based education system by employing project-based teaching-learning techniques with more emphasis on skill
development. Centres of Excellence and specialized labs like Engineering Exploration Lab and Experiential Learning Lab help carry-out projects effectively.
Implementation of LMS with Microsoft TEAMS ensures exceptional online education. QS-IGauge has certified BNMIT with E-Lead certification for
excellence in E-Learning and Academic Digitization.
The Career and Professional development cell create global professionals through structured training programs,enabling 95% of eligible students to be
placed across over 150 companies with attractive salary packages.
BNMIT is NAAC accredited with "A" grade and all eligible programs are NBA accredited. Most of the surveys conducted by agencies like TIMES, OUTLOOK, Dataquest
and India Today have ranked BNMIT one amongst top Institutions in the country
            </p>
          </div>
        </div>
        <div className="venue-container">
          <div className="venueimg">
            <img src={blore} alt="" />
            <p style={{ textAlign: "center" }}>
              Bengaluru, Capital Of Karnataka
            </p>
          </div>
          <div className="venue-content">
            <span style={{ fontSize: "3.5rem" }}>Bengaluru</span>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ fontWeight: "bold" }}>Climate</p>
                <p>
                  Bengaluru has a tropical savanna climate (Köppen climate
                  classification Aw) with distinct wet and dry seasons. Due to
                  its high elevation, Bengaluru usually enjoys a more moderate
                  climate throughout the year, although occasional heat waves
                  can make summer somewhat uncomfortable.
                </p>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ fontWeight: "bold" }}>People</p>
                <p>
                  It has a population of more than 8 million and a metropolitan
                  population of around 11 million, making it the third most
                  populous city and fifth most populous urban agglomeration in
                  India.
                </p>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ fontWeight: "bold" }}>Language</p>
                <p>
                  Bengaluru's diversity not withstanding, the city's primary
                  spoken language, lingua franca, and chief administrative
                  language is Kannada, the state language of Karnataka, listed
                  in the 2011 Census as the mother tongue of 44.62% of the
                  city's population.
                </p>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ fontWeight: "bold" }}>Transportation</p>
                <p>
                  Transport in Bengaluru consists of several intracity commute
                  modes such as BMTC buses, Namma Metro rail services, taxis and
                  auto rickshaws, as well as several intercity forms of
                  transport: Government operated KSRTC, NWKRTC, KKRTC, other
                  states RTC buses, Private bus operators, trains, and flights.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutConference;